import { render, staticRenderFns } from "./myExam.vue?vue&type=template&id=5d5ae34f"
import script from "./myExam.vue?vue&type=script&lang=js"
export * from "./myExam.vue?vue&type=script&lang=js"
import style0 from "./myExam.vue?vue&type=style&index=0&id=5d5ae34f&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports